import React from "react";
import { TermsContent } from "../utils/content";
import {
  Container,
  InnerPageWrapper,
  Wrapper,
} from "../assets/styles/common.style";
import { Header, Footer } from "../components";
import { InnerPageHead } from "../ui";

export const Terms = () => (
  <InnerPageWrapper>
    <Header />

    <Wrapper>
      <Container className="text-white text-center mt-6 mx-auto xl:w-3/4">
        <InnerPageHead title={TermsContent.title} />
        <div
          className="text-left mt-10"
          dangerouslySetInnerHTML={{
            __html: TermsContent.description,
          }}
        />
      </Container>
    </Wrapper>

    <Footer />
  </InnerPageWrapper>
);
